export default __webpack_public_path__ + "static/media/favouriteZone.89180b75.png";